export default __webpack_public_path__ + "static/media/delete.1b652d37.svg";